import { getImageActionTypes, actionTypes } from './actions';

const initialState = {
  images: {},
};

const handleGetImageRequest = (state, action) => {
  const images = { ...state.images };
  const targetImage = {
    id: action.id,
    loading: true,
  };
  images[targetImage.id] = targetImage;
  return {
    ...state,
    images,
  };
};

const handleGetImageSuccess = (state, action) => {
  const images = { ...state.images };
  const targetImage = images[action.id];
  if (targetImage) {
    images[targetImage.id] = {
      src: action.src,
      contentType: action.contentType,
      loading: false,
    };
  }
  return {
    ...state,
    images,
  };
};

const handleGetImageError = (state, action) => ({
  ...state,
  error: action.error,
});

const handleClearImages = (state) => ({
  ...state,
  images: {},
});

export default (state = initialState, action) => {
  const handlers = {
    [getImageActionTypes.request]: handleGetImageRequest,
    [getImageActionTypes.success]: handleGetImageSuccess,
    [getImageActionTypes.error]: handleGetImageError,
    [actionTypes.CLEAR_IMAGES]: handleClearImages,
  };

  return handlers[action.type]
    ? handlers[action.type](state, action)
    : state;
};
